import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ParentGenericService} from './parent-generic.service';
import {ModelService} from '@cdk/services/model.service';
import {Desentranhamento} from '@cdk/models';

@Injectable()
export class DesentranhamentoService extends ParentGenericService<Desentranhamento> {
    protected modelService: ModelService;
    protected http = inject(HttpClient);




    constructor() {
        const modelService = inject(ModelService);

        super(modelService, 'administrativo/desentranhamento', Desentranhamento);

        this.modelService = modelService;
    }
}
